var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreIconBig({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 13,
    viewBox: "0 0 3 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.41955 0.0957031C2.09811 0.0957032 2.64818 0.645781 2.64818 1.32434C2.64818 2.00289 2.09811 2.55297 1.41955 2.55297C0.740996 2.55297 0.190918 2.00289 0.190918 1.32434C0.190918 0.645781 0.740996 0.0957031 1.41955 0.0957031Z",
    fill: "#2D2D2D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.41955 5.01023C2.09811 5.01023 2.64818 5.56031 2.64818 6.23887C2.64818 6.91742 2.09811 7.4675 1.41955 7.4675C0.740996 7.4675 0.190918 6.91742 0.190918 6.23887C0.190918 5.56031 0.740996 5.01023 1.41955 5.01023Z",
    fill: "#2D2D2D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.41955 9.92476C2.09811 9.92476 2.64818 10.4748 2.64818 11.1534C2.64818 11.832 2.0981 12.382 1.41955 12.382C0.740995 12.382 0.190918 11.832 0.190918 11.1534C0.190918 10.4748 0.740996 9.92476 1.41955 9.92476Z",
    fill: "#2D2D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreIconBig);
export default __webpack_public_path__ + "static/media/MoreIconBig.a9b839c7efe41ddabc02f079ac565f7f.svg";
export { ForwardRef as ReactComponent };